export default __webpack_public_path__ + "static/media/us-wa.5fa6c037.svg";